/**
 * GovPendentes — Fila de perguntas que precisam de resposta humana.
 * Reusa `/api/pending-questions` do backend.
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Question, ArrowClockwise, ChatCircleText } from "@phosphor-icons/react";

export default function GovPendentes() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/pending-questions");
      setRows(Array.isArray(data) ? data : (data?.items || []));
    } catch { setRows([]); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="gov-pendentes-page">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-emerald-700/70 font-medium mb-1">Atendimento</div>
          <h1 className="font-heading text-2xl font-semibold text-slate-900 tracking-tight flex items-center gap-2">
            <Question size={22} className="text-emerald-700" />
            Perguntas Pendentes
          </h1>
          <p className="text-[12.5px] text-slate-500 mt-0.5">Fila de perguntas que a IA não conseguiu responder — servidor humano responde e a base aprende.</p>
        </div>
        <button onClick={load} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md border border-slate-200 bg-white text-[12px]"><ArrowClockwise size={12} /> Atualizar</button>
      </div>
      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
        {loading && <div className="p-8 text-center text-slate-400 text-[12.5px]">Carregando…</div>}
        {!loading && rows.length === 0 && (
          <div className="p-10 text-center text-[13px] text-slate-500">
            <ChatCircleText size={30} className="mx-auto mb-2 text-slate-300" />
            Nenhuma pergunta pendente. Todos os atendimentos foram respondidos automaticamente pela IA. 🎉
          </div>
        )}
        {!loading && rows.length > 0 && (
          <ul className="divide-y divide-slate-100">
            {rows.map(q => (
              <li key={q.id} data-testid={`pending-${q.id}`} className="p-4 hover:bg-emerald-50/40 transition-colors">
                <div className="font-medium text-slate-900 text-[13px] mb-1">{q.question || q.text || "(sem pergunta)"}</div>
                <div className="text-[11.5px] text-slate-500">
                  {q.customer_name || "Cidadão"} · {q.created_at ? new Date(q.created_at).toLocaleString("pt-BR") : ""}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
